import React from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "app/components/overlays/CustomNoRowsOverlay";
import LinearProgress from '@mui/material/LinearProgress';
import MDBox from "components/MDBox";
import { isEmpty } from "utils/validationUtil";
import { getDateInDDMMYYYYFormat, getDayName } from "utils/dateUtil";
import { getHolidayTypeLabel } from "utils/holidayTypeLabel";

const columns = [
    { field: 'date', headerName: 'Date', width: 200, valueGetter: (value, row) => {return getDateInDDMMYYYYFormat(row.date)+' ('+getDayName(row.date)+')'} },
    { field: 'status', headerName: 'Status', width: 200, valueGetter: (value, row) => showHolidayStatus(row.date) },
    { field: 'name', headerName: 'Occasion', width: 300 },
    // valueGetter renders the label as plain text and drives sorting/filtering on it.
    { field: 'holidayType', headerName: 'Type', width: 120,
      valueGetter: (value, row) => getHolidayTypeLabel(row.holidayType) },
    { field: 'description', headerName: 'Description', width: 300 },
]

const showHolidayStatus = (date) => {
    var _date = new Date(date);
    var _currDate = new Date();
    if (_date < _currDate) return "PAST";
    if (_date.getMonth() === _currDate.getMonth() && _date.getFullYear() === _currDate.getFullYear()) return "THIS-MONTH";
    if ((_date.getMonth() === _currDate.getMonth()+1 && _date.getFullYear() === _currDate.getFullYear()) ||
        (_currDate.getMonth() === 11 && _date.getMonth() === 0 && _date.getFullYear() === _currDate.getFullYear()+1)) return "NEXT-MONTH";
    if (_date > _currDate) return "FUTURE";
    return "UPCOMING";
}

export const HolidayDataGridBase = (props) => {
    const [pageSize, setPageSize] = React.useState(10);

    const getData = () => {
        if(isEmpty(props.holidayData) || props.holidayData.length === 0)
            return [];
        else
            return props.holidayData;
    }

    return (
        <MDBox pt={3}
            py={3}
            px={2}
            height={500}
        >
            <DataGrid
                density="compact"
                rows={ getData() }
                getRowId={(row) => row.date}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                components={{
                    LoadingOverlay: LinearProgress,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
                // loading
                getCellClassName = {(params) => params.field === "status" ? `holiday-app-theme--${showHolidayStatus(params.row.date).toLowerCase()}` : "" }
            />
        </MDBox>  
    );
}

HolidayDataGridBase.propTypes = {
    holidayData: PropTypes.array.isRequired
}